module.exports = __webpack_public_path__ + "img/DSC_9275.be53b6ec.jpg";